<template>
  <div class="container page-section verity-mt">
    <div class="text-center mv15">
      <div class="col-md-12 icon-password">
        <img
          src="/img/icons/reset_password.svg"
          alt="Image"
        >
      </div>
    </div>
    <div class="col-md-12">
      <div class="content">
        <div class="row text-center">
          <div class="col-md-12 mv15">
            <h3>{{ $t('label.title.success') }}</h3>
            <label>{{ $t('label.messages.resetPassword') }}</label>
          </div>
        </div>
        <div class="row text-center">
          <div class="col-md-12 mv15">
            <button
              class="btn btn-cash-hero btn-lg btn-block"
              @click="$router.push({name: 'login'})"
            >
              {{ $t('global.btn.goToLoginPage') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoPage',
  metaInfo () {
    return {
      title: 'Reset Password Successful',
      titleTemplate: '%s | Cash Hero',
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'Reset Password Successful' }
      ]
    }
  }
}
</script>

<style scoped>
.label-error {
  float: left;
}

.verity-mt {
  margin-top: 0;
}

.icon-password img {
  width: 15%;
}

.content {
  margin: 0 auto;
  width: 50%;
}

.mv15 {
  margin: 6px 0;
}

@media (max-width: 992px) {
  .icon-password img {
    width: 22%;
  }

  .icon-password {
    padding-top: 4rem;
  }

  .content {
    width: 65%;
  }
}

@media (max-width: 768px) {
  .content {
    width: 90%;
  }

  .icon-password img {
    width: 25%;
  }
}

@media (max-width: 576px) {
  .verity-mt {
    margin-top: 1rem;
  }

  .icon-password img {
    width: 35%;
  }

  .icon-password {
    padding-top: 1rem;
  }

  .content {
    width: 100%;
  }
}
</style>
